import { HighlightText } from "@/components/MedicalChronology/HighlightText";
import React from "react";

import { formatCitationPages, getCitationFileLabel } from "../utils/visitFormatting";
import { VisitCitationEmpty } from "./VisitCitationEmpty";
import type { VisitCitationListProps } from "./types";
import { getCitationKey } from "./utils";

export const VisitCitationInlineList = ({
  citations,
  fileMapping,
  onCitationClick,
  highlightQuery,
}: VisitCitationListProps) => {
  if (citations.length === 0) return <VisitCitationEmpty />;

  return (
    <span className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
      {citations.map((citation, index) => (
        <React.Fragment key={getCitationKey(citation, index)}>
          {index > 0 && <span aria-hidden="true" className="h-1 w-1 rounded-full bg-neutral-300" />}
          <button
            type="button"
            onClick={() => onCitationClick(citation)}
            className="flex min-w-0 items-center gap-1 transition-colors hover:text-primary focus-visible:shadow-focus focus-visible:outline-none"
          >
            <span className="max-w-[200px] truncate">
              <HighlightText
                highlightQuery={highlightQuery}
                text={getCitationFileLabel(citation, fileMapping)}
              />
            </span>{" "}
            <span className="shrink-0">{formatCitationPages(citation)}</span>
          </button>
        </React.Fragment>
      ))}
    </span>
  );
};
